export const AccountBenefitsSVG = (props) => (
  <svg
    width={40}
    height={41}
    viewBox="0 0 40 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="Free Delivery">
      <path
        id="Stroke 1 (Stroke)"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.30005 8.57715H38.8071V35.0173H1.30005V8.57715ZM2.70005 9.97715V33.6173H37.4071V9.97715H2.70005Z"
        fill="black"
      />
      <path
        id="Stroke 3 (Stroke)"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.44163 8.8549C1.67471 8.54647 2.1137 8.48539 2.42213 8.71848L11.449 15.5403L20.0534 22.0431L37.6851 8.71848C37.9935 8.48539 38.4325 8.54647 38.6656 8.8549C38.8987 9.16333 38.8376 9.60232 38.5292 9.83541L20.4754 23.479L19.6313 23.4789L10.6049 16.6572L1.57805 9.83541C1.26962 9.60232 1.20854 9.16333 1.44163 8.8549Z"
        fill="black"
      />
      <path
        id="Stroke 4 (Stroke)"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.3538 34.2335V9.50562H20.7538V34.2335H19.3538Z"
        fill="black"
      />
      <path
        id="Stroke 5 (Stroke)"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.9087 6.20249C23.5308 6.20249 23.1825 6.39298 22.933 6.71192C20.9414 9.25702 18.9006 11.3399 17.3585 12.7863C16.587 13.51 15.9388 14.0757 15.4821 14.4615C15.2537 14.6545 15.0731 14.8026 14.9488 14.903C14.8866 14.9533 14.8385 14.9917 14.8055 15.0178L14.7674 15.0478L14.7572 15.0558L14.7543 15.058L14.7534 15.0587C14.7533 15.0588 14.7529 15.0591 14.3236 14.5062C13.8944 13.9532 13.8943 13.9533 13.8943 13.9533L13.8961 13.9519L13.9038 13.9459L13.9365 13.9201C13.9659 13.8968 14.0103 13.8614 14.0688 13.8142C14.1856 13.7197 14.3584 13.5781 14.5786 13.3921C15.019 13.02 15.6489 12.4704 16.4008 11.7652C17.9057 10.3537 19.894 8.32374 21.8304 5.8493M21.8304 5.8493C22.2996 5.24949 23.0312 4.80249 23.9087 4.80249C25.3375 4.80249 26.4963 5.96049 26.4963 7.38966C26.4963 8.81863 25.3376 9.97723 23.9087 9.97723V8.57723C24.5645 8.57723 25.0963 8.04543 25.0963 7.38966C25.0963 6.73408 24.5646 6.20249 23.9087 6.20249"
        fill="black"
      />
      <path
        id="Stroke 5 (Stroke)_2"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.4819 6.20249C16.8599 6.20249 17.2081 6.39298 17.4576 6.71192C19.4492 9.25702 21.49 11.3399 23.0321 12.7863C23.8037 13.51 24.4518 14.0757 24.9085 14.4615C25.1369 14.6545 25.3175 14.8026 25.4419 14.903C25.504 14.9533 25.5522 14.9917 25.5852 15.0178L25.6232 15.0478L25.6335 15.0558L25.6364 15.058L25.6372 15.0587C25.6374 15.0588 25.6378 15.0591 26.067 14.5062C26.4962 13.9532 26.4963 13.9533 26.4963 13.9533L26.4945 13.9519L26.4869 13.9459L26.4541 13.9201C26.4247 13.8968 26.3803 13.8614 26.3218 13.8142C26.205 13.7197 26.0322 13.5781 25.8121 13.3921C25.3716 13.02 24.7418 12.4704 23.9898 11.7652C22.4849 10.3537 20.4966 8.32374 18.5603 5.8493M18.5603 5.8493C18.091 5.24949 17.3594 4.80249 16.4819 4.80249C15.0532 4.80249 13.8944 5.96049 13.8944 7.38966C13.8944 8.81863 15.053 9.97723 16.4819 9.97723V8.57723C15.8262 8.57723 15.2944 8.04543 15.2944 7.38966C15.2944 6.73408 15.826 6.20249 16.4819 6.20249"
        fill="black"
      />
    </g>
  </svg>
);
